module.exports = __webpack_public_path__ + "static/media/lungdis_help536.c0881d6a.png";